import React from 'react';

const Board = () => {
  return (
    <div className="vertical-steps big-padding">
      <div className="container">
        <div className="bg-image">
          <div className="subtitle bigger without">
            How do we recruit?
            <div className="extra">
              Our recruitment process strongly depends on the project to which
              you are applying. Here’s a general overview of our recruiting
              process.
            </div>
          </div>
          <div className="step first mt-5">
            <div className="left-section">
              <div className="number-border">
                <div className="number-step">
                  <span>1</span>
                </div>
              </div>
            </div>
            <div className="right-section">
              <h3 className="tt">Task</h3>
              <div className="content">
                <div className="row">
                  <div className="col-md-6">
                    <p>
                      We will prepare a task to test your skills and see how you
                      approach solving problems. Here you can show us all your
                      talents!
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg">
        <div className="container">
          <div className="step bg pb-4">
            <div className="left-section">
              <div className="number-border">
                <div className="number-step">
                  <span>2</span>
                </div>
              </div>
            </div>
            <div className="right-section">
              <h3 className="tt">Interview</h3>
              <div className="content">
                <div className="row">
                  <div className="col-md-6">
                    <p>
                      In this step you can expect soft and technical questions
                      as well as details on the project to which you’re
                      applying.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="">
        <div className="container">
          <div className="step fourth pt-5">
            <div className="left-section">
              <div className="number-border">
                <div className="number-step">
                  <span>3</span>
                </div>
              </div>
            </div>
            <div className="right-section">
              <h3 className="tt">Decision</h3>
              <div className="content">
                <div className="row">
                  <div className="col-md-6">
                    <p>
                      Once we’re sure that you’re a great fit for the project,
                      we will make you an offer.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Board;
